import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { FolderPath } from '../../folder.model';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-folder-paths',
  standalone: true,
  templateUrl: './folder-paths.component.html',
  styleUrls: ['./folder-paths.component.scss'],
  imports: [CommonModule, NgbDropdownModule],
})
export class FolderPathsComponent {
  @Input() paths: FolderPath[];
  @Output() clickPath = new EventEmitter<number>();

  private translateService = inject(TranslateService);

  onclickPath(path: FolderPath, index: number) {
    if (index !== this.paths.length - 1) {
      this.clickPath.emit(path.id);
    }
  }

  get currentLang() {
    return this.translateService.getCurrentLang();
  }
}
